/**
 * The deep link that opens a scan's Process Status panel.
 *
 * The panel is viewer state, not a route, so a host that HAS the viewer opens it
 * directly. Two hosts do not: the project page raises the same reprocess toast
 * with no viewer on screen at all, and the standalone floor-plan page has its
 * own menu but not the wrapper's panel. Both need to be able to say "here is
 * where to watch it" without knowing anything about the panel's state, which is
 * what a URL is for.
 *
 * Rides alongside `navigationMode` in the query string rather than becoming a
 * route of its own: it is a panel over whatever view you land in, and the scan
 * URL stays the single address for a scan.
 */
export const PROCESS_STATUS_PARAM = 'panel';
export const PROCESS_STATUS_PARAM_VALUE = 'process-status';

/**
 * Should the viewer open the panel on arrival?
 *
 * @param {URLSearchParams|null} searchParams
 * @returns {boolean}
 */
export function opensProcessStatus(searchParams) {
  return searchParams?.get(PROCESS_STATUS_PARAM) === PROCESS_STATUS_PARAM_VALUE;
}

/**
 * The scan URL with the panel requested.
 *
 * `projectId` is carried when known for the same reason every other scan link
 * carries it — the breadcrumb and the back action need it, and it differs per
 * structure, so it can never be inferred at the destination.
 *
 * @param {Object} args
 * @param {string} args.structureId
 * @param {string|null} [args.projectId]
 * @returns {string} a path + query, for `navigate()`
 */
export function processStatusUrl({ structureId, projectId = null }) {
  const params = new URLSearchParams();
  if (projectId) params.set('projectId', projectId);
  params.set(PROCESS_STATUS_PARAM, PROCESS_STATUS_PARAM_VALUE);
  return `/structure/${structureId}?${params.toString()}`;
}
